import { createUseStyles } from 'react-jss';

const styles = {
  content: { paddingBottom: '5rem', position: 'relative', minHeight: '10rem' },
  tableContent: { maxWidth: '80vw' },
  emptyTableContent: { maxWidth: '80vw', minHeight: '10rem', width: 'auto' },
};

const createStyles = createUseStyles(styles);
export { createStyles };
